/**
 * @param {Array} array Array with objects
 * @param {String} key The key to sort by
 * @returns Alphabetically sorted array
 */
export default function sortAlphabetically(array, key) {
	return array.sort((a, b) => a[key]?.localeCompare(b[key]));
}
